import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { MediaPlayer } from 'dashjs';

import {updateCurrentTime, setVideoDuration, setSeekVideo, startDriving, pauseDriving, startOver, closeStory, openMenu} from '../../state/actions/timeline';

import Icons from '../Shared/Icons';

import './Video.scss';

class Video extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            loading: true
        }
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.isDriving  !== nextProps.isDriving) {
            nextProps.isDriving ? this.play() : this.pause();
        }
    }

    componentDidUpdate (){
        if (this.props.seekVideo) {
            this.seek(this.props.seekVideo);
            this.props.isDriving ? this.play() : this.pause();
        }
    }

    componentDidMount () {
        this.props.isDriving ? this.play() : this.pause();

        this.setCurrentTime(this.props.currentTime);
    }

    render() {
        const className = classNames({
            "Video__container": true,
            "Video__container--playing": this.props.isDriving
        });

        const playButton = !this.props.tripStarted || this.props.isDriving || this.props.isMenuOpen || this.props.story.type === "story" ? null : <div className="Video__playButton" onClick={this.props.startDriving}><Icons type="play" /></div>;

        const loader = this.props.tripStarted && this.state.loading && this.props.isDriving ? <div className="signal"></div> : null;

        const videos = this.props.video.videos;

        return (
            <div className="Video">
                {playButton}
                {loader}

                <div className={className}>
                    <video preload="auto" name={this.props.videoName} ref="video"
                           onTimeUpdate={() => { this.onTimeUpdate() }}
                           onCanPlay={() => { this.onCanPlay() }}
                           onEnded={() => { this.onEnded() }}
                           onClick={() => this.onClickVideo() }
                           onWaiting={() => this.onWaiting()}
                           onPlaying={() => this.onPlaying()}
                           onSeeking={() => this.onSeeking()}
                           onSeeked={() => this.onSeeked()}
                           playsInline
                           muted={this.props.audioMuted}
                           key={videos.id}
                    >
                        <source src={videos.dash.src} type={videos.dash.type} />
                        <source src={videos.mobile.src} type={videos.mobile.type} />

                        <p>
                          Download deze video:
                          <a href={videos.mobile.src}>HD</a>
                          <a href={videos.desktop.src}>SD</a>
                        </p>
                    </video>
                </div>
            </div>
        );
    }

    onWaiting () {
        this.setState({loading: true});
    }

    onPlaying () {
        this.setState({loading: false});
    }

    onSeeking () {
        this.setState({loading: true});
    }

    onSeeked () {
        this.setState({loading: false});
    }

    onClickVideo () {
        if (!this.props.tripStarted) return false;

        if(this.props.isDriving) {
            this.props.pauseDriving();
        } else {
            this.props.startDriving();
        }

        if(this.props.isStoryOpen) this.context.router.push("/");
    }

    /**
     * Set video to certain time
     * @param time
     */
     setCurrentTime (time) {
        if(time) this.refs.video.currentTime = time;
    }

    /**
     * Update the current time
     */
    onTimeUpdate () {
        this.props.updateCurrentTime(this.refs.video.currentTime);
    }

    /**
     * Set the video duration time
     */
    onCanPlay () {
        this.props.setVideoDuration(this.refs.video.duration);
    }

    /**
     * Restart
     */
    onEnded () {
        this.props.startOver();
    }

    /**
     * Pause video
     */
    pause () {
        this.refs.video.pause();
    }

    /**
     * Play video
     */
    play () {
        this.refs.video.play();
    }

    /**
     * Seek moment in video
     */
    seek (time) {
        this.setCurrentTime(time);
        this.props.setSeekVideo(false);
    }

    /**
     * Start driving for the first time
     */
    start () {
        this.props.startDriving();
    }

}

function mapStateToProps({video, timeline, responsive}) {
    return {
        video,
        responsive,
        isDriving: timeline.isDriving,
        story: timeline.showStory,
        isStoryOpen: timeline.storyIsOpen,
        currentTime: timeline.currentTime,
        seekVideo: timeline.seekVideo,
        tripStarted: timeline.tripStarted,
        isMenuOpen: timeline.isMenuOpen,
        audioMuted: timeline.audioMuted
    }
}

export default connect(mapStateToProps, {updateCurrentTime, setVideoDuration, setSeekVideo, startDriving, pauseDriving, startOver, closeStory, openMenu})(Video);



// WEBPACK FOOTER //
// ./src/components/Video/index.js